import { SELECT_TAB } from './ActionTypes';
import { setValueInLocalStorage } from '../utils/localStorageHelper';
import { FORECAST_TAB_KEY } from '../utils/localStorageKeys';
export function selectTab(tab) {
  return dispatch => {
    setValueInLocalStorage(FORECAST_TAB_KEY, tab);
    dispatch({
      type: SELECT_TAB,
      payload: tab
    });
  };
}